export const NICES = ["Nice!", "Super!", "Cool!", "Spectacular!", "Awesome!", "Well done!", "Well played!", "Sweet!", "You rock!"];
export const BADS = ["Wrong!", "Nice...try!", "Incorrect!", "Try again!", "Sad!", "Very sad!"];

export enum QuizType {
    US_LICENSE_PLATES,
    US_ADOPT_A_HIGHWAY,
    US_STATE_HIGHWAY,
    US_COUNTY_SECONDARY_HIGHWAY,
    US_STATE_FLAGS,
    US_WINDSHIELD_STICKERS,
    NA_ABBREVIATIONS,
    NA_AREA_CODES,
    NA_TREE_SPECIES,
    BRAZIL_AREA_CODES,
    BRAZIL_ABBREVIATIONS,
    BRAZIL_POSTCODES,
    EU_BOLLARDS,
    EU_CHEVRONS,
    EU_DOMAINS,
    EU_GUARDRAILS,
    EU_FLAGS,
    EU_PEDESTRIAN_CROSSINGS,
    MONG_DRIVING_DIRECTION,
    MONG_CAR_META,
    INDONESIA_KABUPATEN,
    PHILLIPINES_PROVINCES,
    PHILLIPINES_REGIONS,
    PHILLIPINES_PLATES,
    VIETNAM_PROVINCES,
    VIETNAM_AREA_CODES,
    VIETNAM_LICENSE_PLATE_CODES,
    VIETNAM_REGIONAL_PLACE_NAMES,
    VIETNAM_POLES,
    NIGERIA_STATES,
    KENYA_COUNTIES,
    AUSTRALIA_PLATES,
    SOUTH_AFRICA_PLATES,
    SOUTH_AFRICA_PROVINCES,
    JAPAN_AREACODES,
    JAPAN_PREFECTURES,
    JAPAN_POLE_PLATES,
    JAPAN_POLE_REFLECTORS,
    JAPAN_POLE_ATTACHMENTS,
    JAPAN_KANJI,
    JAPAN_REGIONS,
}

export enum LocalStorageStreakKeys {
    US_LICENSE_PLATES = "bestStreak",
    US_ADOPT_A_HIGHWAY = "us_adopt_a_highway_bestStreak",
    US_STATE_HIGHWAY = "us_state_highway_bestStreak",
    US_COUNTY_SECONDARY_HIGHWAY = "us_county_secondary_highway_bestStreak",
    US_STATE_FLAGS = "us_state_flags_bestStreak",
    US_WINDSHIELD_STICKERS = "us_windshield_stickers_bestStreak",
    NA_ABBREVIATIONS = "na_abbreviations_bestStreak",
    NA_AREA_CODES = "na_area_codes_bestStreak",
    NA_TREE_SPECIES = "na_tree_species_bestStreak",
    BRAZIL_AREA_CODES = "brazil_areacodes_bestStreak",
    BRAZIL_ABBREVIATIONS = "brazil_abbreviations_bestStreak",
    BRAZIL_POSTCODES = "brazil_postcodes_bestStreak",
    EU_BOLLARDS = "eu_bollards_bestStreak",
    EU_CHEVRONS = "eu_chevrons_bestStreak",
    EU_DOMAINS = "eu_domains_bestStreak",
    EU_GUARDRAILS = "eu_guardrails_bestStreak",
    EU_FLAGS = "eu_flags_bestStreak",
    EU_PEDESTRIAN_CROSSINGS = "eu_pedestrian_crossings_bestStreak",
    MONG_DRIVING_DIRECTION = "mongolia_driving_direction_bestStreak",
    MONG_CAR_META = "mongolia_car_meta_bestStreak",
    INDONESIA_KABUPATEN = "indonesia_kabupaten_bestStreak",
    PHILLIPINES_PROVINCES = "phillipines_provinces_bestStreak",
    PHILLIPINES_REGIONS = "phillipines_regions_bestStreak",
    PHILLIPINES_PLATES = "phillipines_plates_bestStreak",
    VIETNAM_PROVINCES = "vietnam_provinces_bestStreak",
    VIETNAM_AREA_CODES = "vietnam_areacodes_bestStreak",
    VIETNAM_LICENSE_PLATE_CODES = "vietnam_license_plate_codes_bestStreak",
    VIETNAM_REGIONAL_PLACE_NAMES = "vietnam_regional_place_names_bestStreak",
    VIETNAM_POLES = "vietnam_poles_bestStreak",
    NIGERIA_STATES = "nigeria_states_bestStreak",
    KENYA_COUNTIES = "kenya_states_bestStreak",
    AUSTRALIA_PLATES = "australia_plates_bestStreak",
    SOUTH_AFRICA_PLATES = "south_africa_plates_bestStreak",
    SOUTH_AFRICA_PROVINCES = "south_africa_provinces_bestStreak",
    JAPAN_AREACODES = "japan_areacodes_bestStreak",
    JAPAN_PREFECTURES = "japan_prefectures_bestStreak",
    JAPAN_POLE_PLATES = "japan_pole_plates_bestStreak",
    JAPAN_POLE_REFLECTORS = "japan_pole_reflectors_bestStreak",
    JAPAN_POLE_ATTACHMENTS = "japan_pole_attachments_bestStreak",
    JAPAN_KANJI = "japan_kanji_bestStreak",
    JAPAN_REGIONS = "japan_regions_bestStreak",
}

export const MAP_COLOR = "#FF5533";
export const MAP_HOVER_COLOR = "#efd900";
export const MAP_LAST_COLOR = "#72b000";
export const MAP_SELECT_COLOR = "#fcba03";

export const CLICK_DRAG_DISTANCE_THRESHOLD = 10; // pixels: if the mouse moves more than this distance between mousedown and mouseup, we consider it a drag, not a click.
